import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";
import { LightningIcon } from "src/assets/icons";
import { timeAgo } from "src/utils";
import { YELLOW_ALERT } from "src/constants/colors";

const CellContainer = styled(BaseCell)`
  gap: 4px;
`;
const IconWrapper = styled.div`
  color: ${YELLOW_ALERT};
`;

interface LastUpdateCellProps {
  date: string;
}

export const LastUpdateCell = ({ date }: LastUpdateCellProps) => (
  <CellContainer>
    <IconWrapper>
      <LightningIcon />
    </IconWrapper>
    {timeAgo(date)}
  </CellContainer>
);
